(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.vybe-header');
    if (!header) return;

    function updateScrolledState() {
      header.classList.toggle('is-scrolled', window.scrollY > 0);
    }

    updateScrolledState();
    window.addEventListener('scroll', updateScrolledState, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vybe-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vybe-announcement-bar]').forEach(function (bar) {
    var track = bar.querySelector('[data-vybe-announcement-track]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;

    var index = items.findIndex(function (item) {
      return item.hasAttribute('data-active');
    });
    if (index < 0) index = 0;

    var prevButton = bar.querySelector('[data-vybe-announcement-prev]');
    var nextButton = bar.querySelector('[data-vybe-announcement-next]');
    var timer = null;

    function show(newIndex) {
      items[index].removeAttribute('data-active');
      index = (newIndex + items.length) % items.length;
      items[index].setAttribute('data-active', '');
    }

    function start() {
      stop();
      timer = window.setInterval(function () {
        show(index + 1);
      }, 10000);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        show(index - 1);
        start();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        show(index + 1);
        start();
      });
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vybe-feature-icons"] && !Shopify.designMode) return;
  try {
    
  // Duplicate the tags once so the phone ticker can loop seamlessly. The
  // copies are hidden from screen readers and only shown on phones (CSS).
  document.querySelectorAll('[data-vybe-feature-icons]').forEach(function (section) {
    var row = section.querySelector('[data-vybe-feature-icons-row]');
    if (!row || row.querySelector('[data-ticker-clone]')) return;
    Array.prototype.slice.call(row.children).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('data-ticker-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      row.appendChild(clone);
    });
    section.classList.add('vybe-feature-icons--ticker');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vybe-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vybe-gallery-track]').forEach(function (track) {
      var originalFrames = Array.prototype.slice.call(track.children);
      var count = originalFrames.length;
      if (!count) return;

      // Prefer a video explicitly marked as the featured one (needed now
      // that there can be more than one); fall back to the first video
      // found if none is marked.
      var originalVideoIndex = originalFrames.findIndex(function (frame) {
        return frame.querySelector('[data-vybe-gallery-key-media]');
      });
      if (originalVideoIndex === -1) {
        originalVideoIndex = originalFrames.findIndex(function (frame) {
          return frame.querySelector('[data-vybe-gallery-video-frame]');
        });
      }

      // Perpetual looping needs actual content to scroll into on either
      // side, not just a wraparound on button clicks — so the whole set
      // is cloned once before and once after the real one. Scrolling
      // (by drag, wheel, or the arrows) past either end of the real
      // middle copy reveals a clone; once that settles, we silently
      // jump to the equivalent frame in the real copy (see
      // normalizeIndex below), which is imperceptible since the content
      // is identical — and leaves a fresh clone buffer on the new side,
      // so it keeps working indefinitely in either direction.
      var beforeClones = originalFrames.map(function (frame) {
        return frame.cloneNode(true);
      });
      var afterClones = originalFrames.map(function (frame) {
        return frame.cloneNode(true);
      });

      var beforeFragment = document.createDocumentFragment();
      beforeClones.forEach(function (clone) {
        beforeFragment.appendChild(clone);
      });
      track.insertBefore(beforeFragment, track.firstChild);

      var afterFragment = document.createDocumentFragment();
      afterClones.forEach(function (clone) {
        afterFragment.appendChild(clone);
      });
      track.appendChild(afterFragment);

      var frames = Array.prototype.slice.call(track.children);

      // Shopify wraps each rendered block in its own `.shopify-block`
      // div, so a video's marker attribute lives one level deeper than
      // `track.children` — map each one back to whichever direct child
      // of the track it lives inside.
      var videoFrames = Array.prototype.slice.call(
        track.querySelectorAll('[data-vybe-gallery-video-frame]')
      );
      var videoIndexes = videoFrames.map(function (videoFrame) {
        var node = videoFrame;
        while (node && node.parentElement !== track) node = node.parentElement;
        return frames.indexOf(node);
      });

      var prevButton = track.parentElement.querySelector('[data-vybe-gallery-prev]');
      var nextButton = track.parentElement.querySelector('[data-vybe-gallery-next]');

      // The centered frame is tracked as plain state rather than
      // re-derived from live scroll geometry on every click — reading
      // position mid-animation (e.g. rapid repeated clicks, before the
      // previous smooth scroll finished) gave inconsistent results and
      // broke the prev/next loop.
      var currentIndex = originalVideoIndex >= 0 ? count + originalVideoIndex : count;
      var settleTimer = null;

      function getCenteredIndex() {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;

        var closestIndex = 0;
        var closestDistance = Infinity;

        frames.forEach(function (frame, index) {
          var rect = frame.getBoundingClientRect();
          var frameCenter = rect.left + rect.width / 2;
          var distance = Math.abs(frameCenter - trackCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      // Photos and videos only load once the gallery is near the screen:
      // photos carry their URLs in data- attributes until then (see the
      // vybe-asset-image snippet), and videos use `preload="none"`.
      var inView = false;
      var photosLoaded = false;

      function loadPhotos() {
        if (photosLoaded) return;
        photosLoaded = true;
        track.querySelectorAll('img[data-src]').forEach(function (img) {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      }

      function applyCurrentIndex(skipAutoplay) {
        frames.forEach(function (frame, index) {
          frame.toggleAttribute('data-centered', index === currentIndex);
        });

        videoFrames.forEach(function (frame, i) {
          var video = frame.querySelector('[data-vybe-gallery-video]');
          if (!video) return;

          if (videoIndexes[i] === currentIndex) {
            frame.setAttribute('data-active', '');
            if (!skipAutoplay && inView && video.paused) video.play().catch(function () {});
            if (!inView && !video.paused) video.pause();
          } else {
            frame.removeAttribute('data-active');
            if (!video.paused) video.pause();
          }
        });
      }

      function scrollToIndex(index, behavior) {
        var target = frames[index];
        var trackRect = track.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var delta = (targetRect.left + targetRect.width / 2) - (trackRect.left + trackRect.width / 2);
        track.scrollBy({ left: delta, behavior: behavior });
      }

      // If the centered frame has drifted into either clone set, jump
      // straight to the same frame in the real, middle copy — instant,
      // so it's invisible — restoring a full buffer on both sides.
      function normalizeIndex() {
        if (currentIndex < count) {
          currentIndex += count;
          applyCurrentIndex();
          scrollToIndex(currentIndex, 'instant');
        } else if (currentIndex >= count * 2) {
          currentIndex -= count;
          applyCurrentIndex();
          scrollToIndex(currentIndex, 'instant');
        }
      }

      function goToIndex(index) {
        currentIndex = index;
        applyCurrentIndex();
        scrollToIndex(currentIndex, 'smooth');
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goToIndex(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goToIndex(currentIndex + 1);
        });
      }

      videoFrames.forEach(function (frame) {
        var video = frame.querySelector('[data-vybe-gallery-video]');
        var toggle = frame.querySelector('[data-vybe-gallery-sound-toggle]');
        if (!video || !toggle) return;

        toggle.addEventListener('click', function () {
          video.muted = !video.muted;
          toggle.setAttribute('data-muted', String(video.muted));
          toggle.setAttribute('aria-pressed', String(!video.muted));
        });
      });

      // Re-syncs `currentIndex` from actual scroll position once
      // scrolling settles — covers free-drag/swipe/wheel navigation,
      // which doesn't go through goToIndex — then normalizes it back
      // into the real copy if the visitor scrolled into a clone.
      // Debounced so it only runs once motion (from a drag, or a
      // button's smooth scroll) truly stops, rather than reading a
      // mid-animation position.
      track.addEventListener(
        'scroll',
        function () {
          if (settleTimer) window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(function () {
            currentIndex = getCenteredIndex();
            applyCurrentIndex();
            normalizeIndex();
          }, 120);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        applyCurrentIndex();
      });

      // Center on the key/featured video explicitly on load rather than
      // relying on the default scroll position.
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var trackRect = track.getBoundingClientRect();
      var keyRect = frames[currentIndex].getBoundingClientRect();
      var keyDelta = (keyRect.left + keyRect.width / 2) - (trackRect.left + trackRect.width / 2);
      // `behavior: 'auto'` would still inherit the track's CSS
      // `scroll-behavior: smooth` and animate; 'instant' is required to
      // actually snap straight there with no transition.
      track.scrollTo({ left: track.scrollLeft + keyDelta, behavior: 'instant' });

      // Respect reduced-motion: don't auto-play the initially centered
      // frame, only once the visitor navigates to it themselves.
      applyCurrentIndex(reducedMotion);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            inView = entries[0].isIntersecting;
            if (inView) loadPhotos();
            applyCurrentIndex(reducedMotion);
          },
          { rootMargin: '400px 0px' }
        ).observe(track);
      } else {
        inView = true;
        loadPhotos();
        applyCurrentIndex(reducedMotion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
